import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06f31902"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex-col-ter mb_20"
}
const _hoisted_2 = {
  class: "title",
  style: {"font-size":"16px","margin-bottom":"20px"}
}

import { ref, reactive } from 'vue'
import { t } from '@/plugins/i18n'
import { ingtPrice } from '@/apis/oem'
import TableLike from '@/components/common/TableLike.vue'
import Tooltip from '@/components/common/Tooltip.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['name', 'data', 'label', 'tooltip'],
  async setup(__props) {

let __temp: any, __restore: any

const props = __props


const {
  ingredientsId,
  ingredientsStyleId,
  ingredientsMaterialsId,
  ingredientsSizeId
} = reactive(props.data)

const columns = [
  { label: '辅料种类', prop: 'ingredientsJp' },
  { label: '起订量件', prop: 'quantity' },
  { label: '单价元', prop: 'unitPrice' },
  { label: '总价元', prop: 'totalPrice' },
  { label: '版费元', prop: 'copyFee', pipe: (v) => v || '-' }
].fort()
const isrequest = [
  ingredientsId,
  ingredientsStyleId,
  ingredientsMaterialsId,
  ingredientsSizeId
].every((v) => v && v !== 'custom')

const data = isrequest
  ? reactive(
    (
  ([__temp,__restore] = _withAsyncContext(() => ingtPrice({
      ingredientsId,
      ingredientsStyleId,
      ingredientsMaterialsId,
      ingredientsSizeId,
      ingredientsLogoPrintModeId: 2
    }).then((res) => res.data))),
  __temp = await __temp,
  __restore(),
  __temp
)
  )
  : []

return (_ctx: any,_cache: any) => {
  return (_unref(isrequest))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(__props.label)), 1),
        _createVNode(Tooltip, { tooltip: __props.tooltip }, {
          default: _withCtx(() => [
            _createVNode(TableLike, {
              columns: _unref(columns),
              data: _unref(data),
              border: true
            }, null, 8, ["columns", "data"])
          ]),
          _: 1
        }, 8, ["tooltip"])
      ]))
    : _createCommentVNode("", true)
}
}

})